module.exports = __webpack_public_path__ + "static/008198-48f745d6518c7275c4b61360cccb22c6.jpg";